import { motion } from "framer-motion";

const CREATOR_PHOTO =
  "https://customer-assets.emergentagent.com/job_sircs-community/artifacts/ehq7yavj_EC2BD580-52B8-4FF2-828B-DF04680053A8.png";

export default function Creator() {
  return (
    <section
      id="creador"
      data-testid="creator-section"
      className="surface-light relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[3/4] overflow-hidden rounded-[8px] bg-ink shadow-[0_30px_70px_-20px_rgba(20,17,13,0.45)]">
            <img
              src={CREATOR_PHOTO}
              alt="Santi Lorenzo — operador de SIRCS"
              className="w-full h-full object-cover"
              data-testid="creator-image"
            />
            <div
              className="absolute inset-0 pointer-events-none mix-blend-soft-light"
              style={{
                background: "radial-gradient(60% 45% at 70% 20%, rgba(201,168,106,0.35), transparent 60%)",
              }}
            />
            {/* Top frame */}
            <div className="absolute top-4 left-4 right-4 flex items-center justify-between font-body text-[10px] uppercase tracking-[0.28em] text-cream/80">
              <span>/operador · 01</span>
              <span className="text-warm">● live</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-taupe/60" />
            <span className="font-body text-[11px] tracking-[0.28em] uppercase text-taupe">
              03 · Santi Lorenzo
            </span>
          </div>
          <h2
            data-testid="creator-headline"
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-normal tracking-[-0.02em] leading-[1.0] text-ink"
          >
            Soy Santi Lorenzo.
            <br />
            <em className="italic text-taupe">Sin promesas vacías.</em>
          </h2>

          <div className="mt-10 space-y-6 font-body text-base sm:text-lg text-[#3A342D] leading-relaxed max-w-2xl">
            <p>
              Llevo años estudiando una sola pregunta:{" "}
              <span className="text-ink">por qué hacemos lo que hacemos, incluso cuando sabemos
              que nos destruye.</span>
            </p>
            <p>
              No vengo de la motivación. Vengo del trabajo profundo con la mente subconsciente,
              los patrones heredados y las decisiones que se toman sin que tú estés presente.
            </p>
            <blockquote className="border-l-2 border-warm pl-6 mt-8 font-display text-2xl sm:text-3xl leading-snug italic text-ink">
              “SIRCS es donde dejas de repetir tu historia y empiezas a crear una nueva desde
              dentro.”
            </blockquote>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
            {[
              { k: "Comunidad", v: "Privada" },
              { k: "Formato", v: "Mentoría" },
              { k: "Inicio", v: "Inmediato" },
            ].map((s) => (
              <div key={s.k} className="bg-cream-soft rounded-xl border border-taupe/15 p-5">
                <div className="font-body text-[10px] uppercase tracking-[0.28em] text-taupe mb-2">
                  {s.k}
                </div>
                <div className="font-display text-xl text-ink">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
